import chatSuggestionSaga from "../sagas/chat-suggestion-sagas";
import chatMsgSaga from "./chat-msg-sagas";
import chatCommonSaga from "./chat-common-sagas";
import chatAuthenticationSaga from "./chat-authentication-sagas";
import { all, fork } from "redux-saga/effects";
import chatSettingSaga from "./chat-setting-sagas";

export default function* rootSaga(): Generator {
    const allTasks = [...chatMsgSaga, ...chatSuggestionSaga, ...chatCommonSaga, ...chatAuthenticationSaga,...chatSettingSaga];

    function* rootWrapper(): Generator {
        yield all(allTasks);
    }

    yield all([yield fork(rootWrapper)]);
}
